import { EventEmitter } from 'fbemitter'

const Emitter = new EventEmitter()

export default Emitter